import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout'
import search from '@/views/search/index'
import store from '@/views/store/index'
import category from '@/views/category/index'
import evaluate from '@/views/evaluate/index'
import index from '@/views/home/index'
import custom from '@/views/custom/index'
import login from '../views/login/login'
import orderDetail from '../views/orderDetail/index'
import orderDetail_B2B from '../views/orderDetail_B2B/index'
import orderDetail_B2B_serv from '../views/orderDetail_B2B_serv/index'
import shoppingTrolley from '../views/shopping-trolley/index'
import productDetail from '../views/product/productDetail'
import productDetail_serv from '../views/product/productDetail_serv'
import placeOrder from '../views/placeOrder/index'
import placeOrder_serv from '../views/placeOrder_serv/index'
import confirmPay_serv from '../views/confirmPay_serv/index'
import afterSale from '../views/afterSale/index'
import addEvaluate from '../views/addEvaluate/index'
import evaluateDetail from '../views/evaluateDetail/index'
import couponProList from '../views/couponProlist/index'
import notificationDetails from '../views/userCenter/messageCenter/notificationDetails'
import shopInfr from '../views/shopInfr/index'
import into from '../views/into/index'

//零售商城
import b2cLayout from '@/views/layout_b2c'
import b2cIndex from '../views/b2c/index'
import b2cCategory from '../views/b2c/category/index'
import b2cProductDetail from '../views/b2c/product/productDetail'
import b2cStore from '../views/b2c/store/index'
import b2cShoppingTrolley from '../views/b2c/shopping-trolley/index'
import b2cSearch from '@/views/b2c/search/index'
import b2cPlaceOrder from '../views/b2c/placeOrder/index'
// import placeOrder_serv from '../views/placeOrder_serv/index'

// 用户中心中心
import userCenter from '../views/userCenter/userCenter'
import couponPackage from '../views/userCenter/couponPackage/couponPackage'
import myOrder from '../views/userCenter/myOrder/myOrder'
import myOrder_serv from '../views/userCenter/myOrder_serv/myOrder'
import companyCertificate from '../views/userCenter/companyCertificate/companyCertificate'
import signingAddress from '../views/userCenter/signingAddress/signingAddress'
import userInfo from '../views/userCenter/userInfo/userInfo'
import orderAfterSale from '../views/userCenter/orderAfterSale/orderAfterSale'
import changePhone from '../views/userCenter/changeInfo/changePhone'
import myEvaluate from '../views/userCenter/myEvaluate/index'
import categoryProduct from '../views/categoryProduct/index'
import rabatt from '../views/promotions/rabatt'
import spitze from '../views/promotions/spitze'
import groupBuy from '../views/promotions/groupBuy'
import browseRecords from '../views/userCenter/browseRecords/browseRecords'
import favorites from '../views/userCenter/favorites/favorites'
import message from '../views/userCenter/messageCenter/message'
import qaList from '../views/userCenter/messageCenter/qalist'
import shopData from '../views/userCenter/shopData/index'
import helpCenter from '../views/helpCenter/index'
import billPayServer from '../views/userCenter/billPayServer/billPayServer'
import personCenter from '../views/userCenter/center/personCenter'
import receipt from '../views/userCenter/receipt/receipt'
import currency from '../views/userCenter/currency/index'
// import changePwd from '../views/userCenter/changeInfo/changePwd'
// import unbindPhone from '../views/userCenter/changeInfo/unbindPhone'

// const error = (resolve) => {
//   import('@/components/error/error').then((module) => {
//     resolve(module)
//   })
// }
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'layout',
      component: layout,
      redirect: {
        name: 'index'
      },
      children: [
        // 首页
        {
          path: '/index',
          name: 'index',
          component: index,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: true,
          }
        },
        // 自定义页面
        {
          path: '/custom',
          name: 'custom',
          component: custom,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: true,
          }
        },
        // 用户中心
        {
          path: '/userCenter',
          name: 'userCenter',
          component: userCenter,
          meta: {
            logoText: '',
            searchVisible: true,
            background: true,
          },
          children: [
            // 订单详情
            {
              path: '/orderDetail',
              name: 'orderDetail',
              component: orderDetail_B2B,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }

            },
            // 订单详情
            {
              path: '/orderDetail_B2B',
              name: 'orderDetail_B2B',
              component: orderDetail_B2B,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            // 订单详情
            {
              path: '/orderDetail_B2B_serv',
              name: 'orderDetail_B2B_serv',
              component: orderDetail_B2B_serv,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/couponPackage',
              name: 'couponPackage',
              component: couponPackage,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/shopData',
              name: 'shopData',
              component: shopData,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/myOrder',
              name: 'myOrder',
              component: myOrder,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/myOrder_serv',
              name: 'myOrder_serv',
              component: myOrder_serv,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/companyCertificate',
              name: 'companyCertificate',
              component: companyCertificate,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/orderAfterSale',
              name: 'orderAfterSale',
              component: orderAfterSale,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/signingAddress',
              name: 'signingAddress',
              component: signingAddress,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/userInfo',
              name: 'userInfo',
              component: userInfo,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/changePhone',
              name: 'changePhone',
              component: changePhone,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/myEvaluate',
              name: 'myEvaluate',
              component: myEvaluate,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/browseRecords',
              name: 'browseRecords',
              component: browseRecords,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/favorites',
              name: 'favorites',
              component: favorites,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/message',
              name: 'message',
              component: message,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/qaList',
              name: 'qaList',
              component: qaList,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/billPayServer',
              name: 'billPayServer',
              component: billPayServer,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/personCenter',
              name: 'personCenter',
              component: personCenter,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            {
              path: '/receipt',
              name: 'receipt',
              component: receipt,
              meta: {
                logoText: '',
                searchVisible: true,
                background: true,
              }
            },
            // {
            //   path: '/unbindPhone',
            //   name: 'unbindPhone',
            //   component: unbindPhone,
            //   meta: {
            //     logoText: '',
            //     searchVisible: false
            //   }
            // }
          ]
        },
        // 搜索
        {
          path: '/search',
          name: 'search',
          component: search,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: true,
          }
        },
        // 店铺主页
        {
          path: '/store',
          name: 'store',
          component: store,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 分类页面
        {
          path: '/category',
          name: 'category',
          component: category,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: true,
          }
        },
        // 评价
        {
          path: '/evaluate',
          name: 'evaluate',
          component: evaluate,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 采购单
        {
          path: '/shopping-trolley',
          name: 'shoppingTrolley',
          component: shoppingTrolley,
          meta: {
            logoText: '',
            searchVisible: true
          }

        },
        // // 订单详情
        // {
        //   path: '/orderDetail',
        //   name: 'orderDetail',
        //   component: orderDetail_B2B,
        //   meta: {
        //     logoText: '',
        //     searchVisible: true
        //   }

        // },
        // // 订单详情
        // {
        //   path: '/orderDetail_B2B',
        //   name: 'orderDetail_B2B',
        //   component: orderDetail_B2B,
        //   meta: {
        //     logoText: '',
        //     searchVisible: true
        //   }
        // },
        // 商品详情
        {
          path: '/productDetail',
          name: 'productDetail',
          component: productDetail,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: true,
          }
        },
        {
          path: '/productDetail_serv',
          name: 'productDetail_serv',
          component: productDetail_serv,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: true,
          }
        },
        {
          path: '/confirmPay_serv',
          name: 'confirmPay_serv',
          component: confirmPay_serv,
          meta: {
            logoText: '',
            searchVisible: true,
            // menuVisible: true,
          }
        },
        // 下单页面
        {
          path: '/placeOrder',
          name: 'placeOrder',
          component: placeOrder,
          meta: {
            logoText: '收银台',
            searchVisible: true
          }
        },
        // 下单页面
        {
          path: '/placeOrder_serv',
          name: 'placeOrder_serv',
          component: placeOrder_serv,
          meta: {
            logoText: '收银台',
            searchVisible: true
          }
        },
        {
          path: '/afterSale',
          name: 'afterSale',
          component: afterSale,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 评价详情
        {
          path: '/evaluateDetail',
          name: 'evaluateDetail',
          component: evaluateDetail,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 追评
        {
          path: '/addEvaluate',
          name: 'addEvaluate',
          component: addEvaluate,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 优惠券商品
        {
          path: '/couponProList',
          name: 'couponProList',
          component: couponProList,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 类别商品
        {
          path: '/categoryProduct',
          name: 'categoryProduct',
          component: categoryProduct,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 折扣专区
        {
          path: '/rabatt',
          name: 'rabatt',
          component: rabatt
        },
        // 秒杀专区
        {
          path: '/spitze',
          name: 'spitze',
          component: spitze
        },
        {
          path: '/groupBuy',
          name: 'groupBuy',
          component: groupBuy
        },
        {
          path: '/notificationDetails',
          name: 'notificationDetails',
          component: notificationDetails
        },
        {
          path: '/helpCenter',
          name: 'helpCenter',
          component: helpCenter
        }
      ]
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: login
    },
    // 开店介绍
    {
      path: '/shopInfr',
      name: 'shopInfr',
      component: shopInfr,
      meta: {
        logoText: '',
        searchVisible: true,
        menuVisible: true,
      }
    },
    // 供应商入驻介绍
    {
      path: '/into',
      name: 'into',
      component: into,
      meta: {
        logoText: '',
        searchVisible: true,
        menuVisible: true,
      }
    },

    //零售商城
    {
      path: '/shop_mall',
      name: 'shop_mall',
      component: b2cLayout,
      redirect: {
        name: 'b2cIndex'
      },
      meta: {
        logoText: '',
        searchVisible: true,
        menuVisible: true,
      },
      children: [
        // 首页
        {
          path: '/shop_mall/index',
          name: 'b2cIndex',
          component: b2cIndex,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: true,
          }
        },
        // 分类页面
        {
          path: '/shop_mall/category',
          name: 'b2cCategory',
          component: b2cCategory,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: true,
          }
        },
        {
          path: '/shop_mall/productDetail',
          name: 'b2cProductDetail',
          component: b2cProductDetail,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: false,
          }
        },
        {
          path: '/shop_mall/store',
          name: 'b2cStore',
          component: b2cStore,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: false,
          }
        },
        {
          path: '/shop_mall/shopping-trolley',
          name: 'b2cShoppingTrolley',
          component: b2cShoppingTrolley,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: false,
          }
        },
        // 下单页面
        {
          path: '/shop_mall/placeOrder',
          name: 'b2cPlaceOrder',
          component: b2cPlaceOrder,
          meta: {
            logoText: '收银台',
            searchVisible: true
          }
        },
        {
          path: '/shop_mall/search',
          name: 'b2cSearch',
          component: b2cSearch,
          meta: {
            logoText: '',
            searchVisible: true,
            menuVisible: false,
          }
        },
        // 用户中心
        {
          path: '/shop_mall/userCenter',
          name: 'userCenter',
          component: userCenter,
          meta: {
            logoText: '',
            searchVisible: true,
            background: true,
          },
          children: [
            // 订单详情
            {
              path: '/shop_mall/orderDetail',
              name: 'orderDetail',
              component: orderDetail_B2B,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }

            },
            // 订单详情
            {
              path: '/shop_mall/orderDetail_B2B',
              name: 'orderDetail_B2B',
              component: orderDetail_B2B,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            // 订单详情
            {
              path: '/shop_mall/orderDetail_B2B_serv',
              name: 'orderDetail_B2B_serv',
              component: orderDetail_B2B_serv,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/couponPackage',
              name: 'couponPackage',
              component: couponPackage,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/shopData',
              name: 'shopData',
              component: shopData,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/myOrder',
              name: 'myOrder',
              component: myOrder,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/myOrder_serv',
              name: 'myOrder_serv',
              component: myOrder_serv,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/companyCertificate',
              name: 'companyCertificate',
              component: companyCertificate,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/orderAfterSale',
              name: 'orderAfterSale',
              component: orderAfterSale,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/signingAddress',
              name: 'signingAddress',
              component: signingAddress,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/userInfo',
              name: 'userInfo',
              component: userInfo,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/changePhone',
              name: 'changePhone',
              component: changePhone,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/myEvaluate',
              name: 'myEvaluate',
              component: myEvaluate,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/browseRecords',
              name: 'browseRecords',
              component: browseRecords,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/favorites',
              name: 'favorites',
              component: favorites,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/message',
              name: 'message',
              component: message,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/qaList',
              name: 'qaList',
              component: qaList,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/billPayServer',
              name: 'billPayServer',
              component: billPayServer,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/personCenter',
              name: 'personCenter',
              component: personCenter,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/receipt',
              name: 'receipt',
              component: receipt,
              meta: {
                logoText: '',
                searchVisible: true,
                background: false,
              }
            },
            {
              path: '/shop_mall/currency',
              name: 'index',
              component: currency,
              meta: {
                logoText: '',
                searchVisible: false,
                background: false,
              }
            },
            // {
            //   path: '/changePwd',
            //   name: 'changePwd',
            //   component: changePwd,
            //   meta: {
            //     logoText: '',
            //     searchVisible: false
            //   }
            // },
            // {
            //   path: '/unbindPhone',
            //   name: 'unbindPhone',
            //   component: unbindPhone,
            //   meta: {
            //     logoText: '',
            //     searchVisible: false
            //   }
            // }
          ]
        },
      ]
    },

  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  // cookie没有值就跳到登陆页
  // let area = sessionStorage.getItem('area')
  // if (area === null && to.name !== 'login' && to.name !== 'overview') {
  //   // Vue.prototype.$message.error('用户未登陆')
  //   next('/login')
  // } else {
  next()
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js